import { render, staticRenderFns } from "./ForumChatMainPage.vue?vue&type=template&id=a22c0888&scoped=true"
import script from "./ForumChatMainPage.vue?vue&type=script&lang=js"
export * from "./ForumChatMainPage.vue?vue&type=script&lang=js"
import style0 from "./ForumChatMainPage.vue?vue&type=style&index=0&id=a22c0888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c0888",
  null
  
)

export default component.exports